// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, Facebook, Twitter, Instagram, Mail, Phone, HelpCircle } from "lucide-react";
// import logo from "../assets/logo8.png"

// const Header = () => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       {/* Top Bar - First Navbar */}
//       <div className="w-full bg-[#0C4550] py-1 text-white">
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between">
//           {/* Contact Info - Left Side */}
//           <div className="flex items-center space-x-4 text-medium">
//             <div className="flex items-center space-x-1">
//               <Mail size={14} />
//               <span>sms.eurofox.com</span>
//             </div>
//           </div>

//           {/* Support Button and Social Media Icons - Right Side */}
//           <div className="flex items-center space-x-4">
//             {/* Support Button */}

//             {/* Social Media Icons */}

//             <div className="flex items-center space-x-3   rounded-xl shadow-lg">
//               <a
//                 href="#"
//                 className="p-1.5  rounded-full bg-blue-500 hover:text-white transition-all duration-300"
//               >
//                 <Facebook size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-sky-400 hover:text-white transition-all duration-300"
//               >
//                 <Twitter size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5  rounded-full bg-pink-500 hover:text-white transition-all duration-300"
//               >
//                 <Instagram size={18} />
//               </a>
//             </div>


//           </div>
//         </div>
//       </div>

//       {/* Main Navigation - Second Navbar */}
//       <nav className="w-full bg-white shadow-md sticky top-0 z-50">
//         <div className="w-full mx-auto px-5 py-4 flex items-center justify-between">

//           {/* Logo - Left Side */}


//           <div className="flex items-center">
//             <img
//               src={logo}
//               alt="Logo"
//               className="h-14 w-auto object-contain"
//             />
//           </div>


//           {/* <h1 className="text-2xl font-bold text-black-600">Eurofox</h1> */}

//           {/* Desktop Menu - Center */}
//           <ul className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2 text-lg">
//             <li>
//               <Link to="/" className="hover:text-blue-600 font-medium transition-colors">
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/pricing" className="hover:text-blue-600 font-medium transition-colors">
//                 Pricing
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className="hover:text-blue-600 font-medium transition-colors">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="hover:text-blue-600 font-medium transition-colors">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           {/* Auth Buttons - Right Side */}
          


//     <div className="flex items-center gap-2">
//       {/* Login with Icon */}
//       <a
//         href="/login"
//         className="flex items-center gap-2 px-3 py-2 text-[15px] font-medium text-[#012B54] transition-all duration-300 rounded-lg group overflow-hidden border border-[#012B54] hover:bg-[#012B54] hover:text-white"
//       >
//         <svg className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
//         </svg>
//         <span>Login</span>
//       </a>

//       {/* Signup with Icon */}
//       <a
//         href="/signup"
//         className="flex items-center gap-2 px-3 py-2 text-[15px] font-medium text-white bg-[#012B54] transition-all duration-300 rounded-lg group overflow-hidden hover:shadow-lg hover:scale-105 transform"
//       >
//         <svg className="w-4 h-4  transition-transform duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
//         </svg>
//         <span>Sign Up</span>
//       </a>
//     </div>









//           {/* Mobile Menu Button */}
//           <button
//             className="md:hidden text-gray-700"
//             onClick={() => setOpen(!open)}
//           >
//             {open ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>

//         {/* Mobile Dropdown */}
//         {open && (
//           <div className="md:hidden bg-white shadow-lg border-t">
//             <ul className="flex flex-col p-4 space-y-4">
//               <li>
//                 <Link
//                   to="/"
//                   className="block py-2 hover:text-blue-600 transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/pricing"
//                   className="block py-2 hover:text-blue-600 transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Pricing
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="block py-2 hover:text-blue-600 transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   About Us
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="block py-2 hover:text-blue-600 transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Contact Us
//                 </Link>
//               </li>
//               <div className="flex flex-col space-y-4 pt-6 border-t border-gray-200">
//                 <button className="px-6 py-3 bg-gradient-to-r from-white to-gray-50 text-blue-600 font-bold rounded-xl border-2 border-blue-500 hover:from-blue-50 hover:to-blue-100 hover:border-blue-600 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 text-center shadow-md">
//                   Login
//                 </button>
//                 <button className="px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold rounded-xl border-2 border-blue-500 hover:from-blue-600 hover:to-blue-700 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 text-center shadow-lg">
//                   Sign Up
//                 </button>
//               </div>
//             </ul>
//           </div>
//         )}
//       </nav>
//     </>
//   );
// };

// export default Header;



// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { Menu, X, Facebook, Twitter, Instagram, Mail } from "lucide-react";

// const Header = () => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       {/* Top Bar - First Navbar */}
//       <div className="w-full bg-[#0C4550] py-1 text-white">
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between">
//           {/* Contact Info - Left Side */}
//           <div className="flex items-center space-x-4 text-medium">
//             <div className="flex items-center space-x-1">
//               <Mail size={14} />
//               <span>sms.eurofox.com</span>
//             </div>
//           </div>

//           {/* Social Media Icons - Right Side */}
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center space-x-3 rounded-xl">
//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-blue-500 hover:text-white transition-all duration-300"
//               >
//                 <Facebook size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-sky-400 hover:text-white transition-all duration-300"
//               >
//                 <Twitter size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-pink-500 hover:text-white transition-all duration-300"
//               >
//                 <Instagram size={18} />
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Navigation - Second Navbar */}
//       <nav className="w-full bg-[#F0EFEB] shadow-md sticky top-0 z-50">
//         <div className="w-full mx-auto px-5 py-4 flex items-center justify-between relative">
          
//           {/* LEFT SIDE: EUROFOX LOGO */}
//           <div className="flex items-center z-10">
//             <Link to="/" className="group cursor-pointer no-underline">
//               <h1 className="text-3xl font-extrabold tracking-widest uppercase flex items-baseline">
//                 {/* EURO Part: Poppins Font, Dark Blue Color (#0C4550) */}
//                 <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] ">
//                   EURO
//                 </span>
                
//                 {/* FOX Part: Roboto Font, Lime Green Color (#C5F637) with Drop Shadow */}
//                 <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">
//                   FOX
//                 </span>
                
//                 {/* Blinking Dot */}
//                 <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
//               </h1>
//             </Link>
//           </div>

//           {/* CENTER: Desktop Menu */}
//           <ul className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2 text-lg font-medium text-gray-700">
//             <li>
//               <Link to="/" className="hover:text-[#0C4550] transition-colors">
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/pricing" className="hover:text-[#0C4550] transition-colors">
//                 Pricing
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className="hover:text-[#0C4550] transition-colors">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="hover:text-[#0C4550] transition-colors">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           {/* RIGHT SIDE: Auth Buttons & Mobile Toggle */}
//           <div className="flex items-center gap-4 z-10">
            
//             {/* Auth Buttons (Hidden on Mobile) */}
//             <div className="hidden md:flex items-center gap-3">
//               {/* Login Button */}
//               <Link
//                 to="/login"
//                 className="flex items-center gap-2 px-4 py-2 text-[15px] font-bold text-[#0C4550] border-2 border-[#0C4550] rounded-lg transition-all duration-300 hover:bg-[#0C4550] hover:text-white group"
//               >
//                 <svg
//                   className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-300"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
//                   />
//                 </svg>
//                 <span>Login</span>
//               </Link>

//               {/* Sign Up Button */}
//               <Link
//                 to="/signup"
//               className="flex items-center gap-2 px-4 py-2 text-[15px] font-bold text-white bg-[#0C4550] border-2  rounded-lg transition-all duration-300 hover:brightness-95 hover:shadow-md transform hover:-translate-y-0.5"
//               >
//                 <svg
//                   className="w-4 h-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
//                   />
//                 </svg>
//                 <span>Sign Up</span>
//               </Link>
//             </div>

//             {/* Mobile Menu Button (Hamburger) */}
//             <button
//               className="md:hidden text-[#0C4550]"
//               onClick={() => setOpen(!open)}
//             >
//               {open ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Dropdown Menu */}
//         {open && (
//           <div className="md:hidden bg-white shadow-lg border-t absolute w-full left-0">
//             <ul className="flex flex-col p-4 space-y-4">
//               <li>
//                 <Link
//                   to="/"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/pricing"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Pricing
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   About Us
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Contact Us
//                 </Link>
//               </li>
              
//               {/* Mobile Auth Buttons */}
//               <div className="flex flex-col space-y-3 pt-4 border-t border-gray-100">
//                 <Link to="/login" onClick={() => setOpen(false)}>
//                   <button className="w-full px-6 py-3 text-[#0C4550] font-bold rounded-xl border-2 border-[#0C4550] hover:bg-gray-50 transition-all duration-300">
//                     Login
//                   </button>
//                 </Link>
//                 <Link to="/signup" onClick={() => setOpen(false)}>
//                   <button className="w-full px-6 py-3 bg-[#C5F637] text-[#0C4550] font-bold rounded-xl hover:brightness-95 transition-all duration-300 shadow-md">
//                     Sign Up
//                   </button>
//                 </Link>
//               </div>
//             </ul>
//           </div>
//         )}
//       </nav>
//     </>
//   );
// };

// export default Header;




// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Menu, X, Facebook, Twitter, Instagram, Mail } from "lucide-react";

// const Header = () => {
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();

//   const handleLoginClick = () => {
//     navigate("/login");
//   };

//   const handleSignupClick = () => {
//     // Navigate to login page with a query parameter for signup mode
//     navigate("/login?mode=signup");
//   };

//   return (
//     <>
//       {/* Top Bar - First Navbar */}
//       <div className="w-full bg-[#0C4550] py-1 text-white">
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between">
//           {/* Contact Info - Left Side */}
//           <div className="flex items-center space-x-4 text-medium">
//             <div className="flex items-center space-x-1">
//               <Mail size={14} />
//               <span>sms.eurofox.com</span>
//             </div>
//           </div>

//           {/* Social Media Icons - Right Side */}
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center space-x-3 rounded-xl">
//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-blue-500 hover:text-white transition-all duration-300"
//               >
//                 <Facebook size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-sky-400 hover:text-white transition-all duration-300"
//               >
//                 <Twitter size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-pink-500 hover:text-white transition-all duration-300"
//               >
//                 <Instagram size={18} />
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Navigation - Second Navbar */}
//       <nav className="w-full bg-[#F0EFEB] shadow-md sticky top-0 z-50">
//         <div className="w-full mx-auto px-5 py-4 flex items-center justify-between relative">
          
//           {/* LEFT SIDE: EUROFOX LOGO */}
//           <div className="flex items-center z-10">
//             <Link to="/" className="group cursor-pointer no-underline">
//               <h1 className="text-3xl font-extrabold tracking-widest uppercase flex items-baseline">
//                 {/* EURO Part: Poppins Font, Dark Blue Color (#0C4550) */}
//                 <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] ">
//                   EURO
//                 </span>
                
//                 {/* FOX Part: Roboto Font, Lime Green Color (#C5F637) with Drop Shadow */}
//                 <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">
//                   FOX
//                 </span>
                
//                 {/* Blinking Dot */}
//                 <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
//               </h1>
//             </Link>
//           </div>

//           {/* CENTER: Desktop Menu */}
//           <ul className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2 text-lg font-medium text-gray-700">
//             <li>
//               <Link to="/" className="hover:text-[#0C4550] transition-colors">
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/pricing" className="hover:text-[#0C4550] transition-colors">
//                 Pricing
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className="hover:text-[#0C4550] transition-colors">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="hover:text-[#0C4550] transition-colors">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           {/* RIGHT SIDE: Auth Buttons & Mobile Toggle */}
//           <div className="flex items-center gap-4 z-10">
            
//             {/* Auth Buttons (Hidden on Mobile) */}
//             <div className="hidden md:flex items-center gap-3">
//               {/* Login Button */}
//               <button
//                 onClick={handleLoginClick}
//                 className="flex items-center gap-2 px-4 py-2 text-[15px] font-bold text-[#0C4550] border-2 border-[#0C4550] rounded-lg transition-all duration-300 hover:bg-[#0C4550] hover:text-white group"
//               >
//                 <svg
//                   className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-300"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
//                   />
//                 </svg>
//                 <span>Login</span>
//               </button>

//               {/* Sign Up Button */}
//               <button
//                 onClick={handleSignupClick}
//                 className="flex items-center gap-2 px-4 py-2 text-[15px] font-bold text-white bg-[#0C4550] border-2 rounded-lg transition-all duration-300 hover:brightness-95 hover:shadow-md transform hover:-translate-y-0.5"
//               >
//                 <svg
//                   className="w-4 h-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
//                   />
//                 </svg>
//                 <span>Sign Up</span>
//               </button>
//             </div>

//             {/* Mobile Menu Button (Hamburger) */}
//             <button
//               className="md:hidden text-[#0C4550]"
//               onClick={() => setOpen(!open)}
//             >
//               {open ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Dropdown Menu */}
//         {open && (
//           <div className="md:hidden bg-white shadow-lg border-t absolute w-full left-0">
//             <ul className="flex flex-col p-4 space-y-4">
//               <li>
//                 <Link
//                   to="/"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/pricing"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Pricing
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   About Us
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Contact Us
//                 </Link>
//               </li>
              
//               {/* Mobile Auth Buttons */}
//               <div className="flex flex-col space-y-3 pt-4 border-t border-gray-100">
//                 <button 
//                   onClick={() => {
//                     handleLoginClick();
//                     setOpen(false);
//                   }} 
//                   className="w-full px-6 py-3 text-[#0C4550] font-bold rounded-xl border-2 border-[#0C4550] hover:bg-gray-50 transition-all duration-300"
//                 >
//                   Login
//                 </button>
//                 <button 
//                   onClick={() => {
//                     handleSignupClick();
//                     setOpen(false);
//                   }}
//                   className="w-full px-6 py-3 bg-[#C5F637] text-[#0C4550] font-bold rounded-xl hover:brightness-95 transition-all duration-300 shadow-md"
//                 >
//                   Sign Up
//                 </button>
//               </div>
//             </ul>
//           </div>
//         )}
//       </nav>
//     </>
//   );
// };

// export default Header;



// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Menu, X, Facebook, Twitter, Instagram, Mail } from "lucide-react";

// const Header = () => {
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();

//   const handleLoginClick = () => {
//     navigate("/login");
//   };

//   const handleSignupClick = () => {
//     // Navigate to login page with a query parameter for signup mode
//     navigate("/login?mode=signup");
//   };

//   return (
//     <>
//       {/* Top Bar - First Navbar */}
//       <div className="w-full bg-[#0C4550] py-1 text-white">
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between">
//           {/* Contact Info - Left Side */}
//           <div className="flex items-center space-x-4 text-medium">
//             <div className="flex items-center space-x-1">
//               <Mail size={14} />
//               <span>sms.eurofox.in</span>
//             </div>
//           </div>

//           {/* Social Media Icons - Right Side */}
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center space-x-3 rounded-xl">
//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-blue-500 hover:text-white transition-all duration-300"
//               >
//                 <Facebook size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-sky-400 hover:text-white transition-all duration-300"
//               >
//                 <Twitter size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-pink-500 hover:text-white transition-all duration-300"
//               >
//                 <Instagram size={18} />
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Navigation - Second Navbar */}
//       <nav className="w-full bg-[#F0EFEB] shadow-md sticky top-0 z-50">
//         {/* CHANGED: Reduced the height by changing py-4 to py-3 */}
//         <div className="w-full mx-auto px-5 py-2.5 flex items-center justify-between relative">
          
//           {/* LEFT SIDE: EUROFOX LOGO */}
//           <div className="flex items-center z-10">
//             <Link to="/" className="group cursor-pointer no-underline">
//               <h1 className="text-3xl font-extrabold tracking-widest uppercase flex items-baseline">
//                 {/* EURO Part: Poppins Font, Dark Blue Color (#0C4550) */}
//                 <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] ">
//                   EURO
//                 </span>
                
//                 {/* FOX Part: Roboto Font, Lime Green Color (#C5F637) with Drop Shadow */}
//                 <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">
//                   FOX
//                 </span>
                
//                 {/* Blinking Dot */}
//                 <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
//               </h1>
//             </Link>
//           </div>

//           {/* CENTER: Desktop Menu */}
//           <ul className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2 text-lg font-medium text-gray-700">
//             <li>
//               <Link to="/" className="hover:text-[#0C4550] transition-colors">
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/pricing" className="hover:text-[#0C4550] transition-colors">
//                 Pricing
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className="hover:text-[#0C4550] transition-colors">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="hover:text-[#0C4550] transition-colors">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           {/* RIGHT SIDE: Auth Buttons & Mobile Toggle */}
//           <div className="flex items-center gap-4 z-10">
            
//             {/* Auth Buttons (Hidden on Mobile) */}
//             <div className="hidden md:flex items-center gap-3">
//               {/* Login Button */}
//               <button
//                 onClick={handleLoginClick}
//                 className="flex items-center gap-2 px-3 py-1.5 text-[15px] font-bold text-[#0C4550] border-2 border-[#0C4550] rounded-lg transition-all duration-300 hover:bg-[#0C4550] hover:text-white group"
//               >
//                 <svg
//                   className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-300"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
//                   />
//                 </svg>
//                 <span>Login</span>
//               </button>

//               {/* Sign Up Button */}
//               <button
//                 onClick={handleSignupClick}
//                 className="flex items-center gap-2 px-3 py-1.5 text-[15px] font-bold text-white bg-[#0C4550] border-2 rounded-lg transition-all duration-300 hover:brightness-95 hover:shadow-md transform hover:-translate-y-0.5"
//               >
//                 <svg
//                   className="w-4 h-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
//                   />
//                 </svg>
//                 <span>Sign Up</span>
//               </button>
//             </div>

//             {/* Mobile Menu Button (Hamburger) */}
//             <button
//               className="md:hidden text-[#0C4550]"
//               onClick={() => setOpen(!open)}
//             >
//               {open ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Dropdown Menu */}
//         {open && (
//           <div className="md:hidden bg-white shadow-lg border-t absolute w-full left-0">
//             <ul className="flex flex-col p-4 space-y-4">
//               <li>
//                 <Link
//                   to="/"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/pricing"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Pricing
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   About Us
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Contact Us
//                 </Link>
//               </li>
              
//               {/* Mobile Auth Buttons */}
//               <div className="flex flex-col space-y-3 pt-4 border-t border-gray-100">
//                 <button 
//                   onClick={() => {
//                     handleLoginClick();
//                     setOpen(false);
//                   }} 
//                   className="w-full px-6 py-3 text-[#0C4550] font-bold rounded-xl border-2 border-[#0C4550] hover:bg-gray-50 transition-all duration-300"
//                 >
//                   Login
//                 </button>
//                 <button 
//                   onClick={() => {
//                     handleSignupClick();
//                     setOpen(false);
//                   }}
//                   className="w-full px-6 py-3 bg-[#C5F637] text-[#0C4550] font-bold rounded-xl hover:brightness-95 transition-all duration-300 shadow-md"
//                 >
//                   Sign Up
//                 </button>
//               </div>
//             </ul>
//           </div>
//         )}
//       </nav>
//     </>
//   );
// };

// export default Header;


// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Menu, X, Facebook, Twitter, Instagram, Mail } from "lucide-react";
// import eurofoxlogo from "../assets/eurofoxlogo.png"

// const Header = () => {
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();

//   const handleLoginClick = () => {
//     navigate("/login");
//   };

//   const handleSignupClick = () => {
//     navigate("/login?mode=signup");
//   };

//   return (
//     <>
//       {/* Top Bar - First Navbar */}
//       <div className="w-full bg-[#0C4550] py-1 text-white relative z-50">
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between">
//           {/* Contact Info - Left Side */}
//           <div className="flex items-center space-x-4 text-medium">
//             <div className="flex items-center space-x-1">
//               <Mail size={14} />
//               <span>sms.eurofox.in</span>
//             </div>
//           </div>

//           {/* Social Media Icons - Right Side */}
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center space-x-3 rounded-xl">
//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-blue-500 hover:text-white transition-all duration-300"
//               >
//                 <Facebook size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-sky-400 hover:text-white transition-all duration-300"
//               >
//                 <Twitter size={18} />
//               </a>

//               <a
//                 href="#"
//                 className="p-1.5 rounded-full bg-pink-500 hover:text-white transition-all duration-300"
//               >
//                 <Instagram size={18} />
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {/* Main Navigation - Second Navbar */}
//       <nav className="w-full bg-[#F0EFEB] shadow-md sticky top-0 z-40">
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between relative">
          
//           {/* LEFT SIDE: EUROFOX LOGO */}
//           <div className="flex items-center">
//             <Link to="/" className="group cursor-pointer no-underline flex items-center relative min-h-[40px]">
              
//               {/* LOGO IMAGE (Absolute) */}
//               <img 
//                 src={eurofoxlogo} 
//                 alt="Eurofox Logo" 
// className="absolute top-1/2 -translate-y-1/2 left-0 w-24 h-24 md:w-36 md:h-36 object-contain transition-all duration-300 drop-shadow-md z-50"              />

//               {/* HEADING TEXT */}
//               {/* CHANGED: Reduced margin from 'ml-20 md:ml-28' to 'ml-14 md:ml-22' to close the gap */}
//               <h1 className="ml-24 md:ml-22 text-2xl font-extrabold tracking-widest uppercase flex items-baseline transition-all duration-300">
//                 <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] ">
//                   EURO
//                 </span>
//                 <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">
//                   FOX
//                 </span>
//                 <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
//               </h1>
//             </Link>
//           </div>

//           {/* CENTER: Desktop Menu */}
//           <ul className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2 text-lg font-medium text-gray-700">
//             <li>
//               <Link to="/" className="hover:text-[#0C4550] transition-colors">
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/pricing" className="hover:text-[#0C4550] transition-colors">
//                 Pricing
//               </Link>
//             </li>
//             <li>
//               <Link to="/about" className="hover:text-[#0C4550] transition-colors">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="hover:text-[#0C4550] transition-colors">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>

//           {/* RIGHT SIDE: Auth Buttons & Mobile Toggle */}
//           <div className="flex items-center gap-4 z-10">
            
//             {/* Auth Buttons (Hidden on Mobile) */}
//             <div className="hidden md:flex items-center gap-3">
//               <button
//                 onClick={handleLoginClick}
//                 className="flex items-center gap-2 px-3 py-1.5 text-[15px] font-bold text-[#0C4550] border-2 border-[#0C4550] rounded-lg transition-all duration-300 hover:bg-[#0C4550] hover:text-white group"
//               >
//                 <svg
//                   className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-300"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
//                   />
//                 </svg>
//                 <span>Login</span>
//               </button>

//               <button
//                 onClick={handleSignupClick}
//                 className="flex items-center gap-2 px-3 py-1.5 text-[15px] font-bold text-white bg-[#0C4550] border-2 rounded-lg transition-all duration-300 hover:brightness-95 hover:shadow-md transform hover:-translate-y-0.5"
//               >
//                 <svg
//                   className="w-4 h-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
//                   />
//                 </svg>
//                 <span>Sign Up</span>
//               </button>
//             </div>

//             {/* Mobile Menu Button */}
//             <button
//               className="md:hidden text-[#0C4550]"
//               onClick={() => setOpen(!open)}
//             >
//               {open ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>

//         {/* Mobile Dropdown Menu */}
//         {open && (
//           <div className="md:hidden bg-white shadow-lg border-t absolute w-full left-0">
//             <ul className="flex flex-col p-4 space-y-4">
//               <li>
//                 <Link
//                   to="/"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/pricing"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Pricing
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/about"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   About Us
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/contact"
//                   className="block py-2 text-gray-700 hover:text-[#0C4550] font-medium transition-colors"
//                   onClick={() => setOpen(false)}
//                 >
//                   Contact Us
//                 </Link>
//               </li>
//               <div className="flex flex-col space-y-3 pt-4 border-t border-gray-100">
//                 <button 
//                   onClick={() => {
//                     handleLoginClick();
//                     setOpen(false);
//                   }} 
//                   className="w-full px-6 py-3 text-[#0C4550] font-bold rounded-xl border-2 border-[#0C4550] hover:bg-gray-50 transition-all duration-300"
//                 >
//                   Login
//                 </button>
//                 <button 
//                   onClick={() => {
//                     handleSignupClick();
//                     setOpen(false);
//                   }}
//                   className="w-full px-6 py-3 bg-[#C5F637] text-[#0C4550] font-bold rounded-xl hover:brightness-95 transition-all duration-300 shadow-md"
//                 >
//                   Sign Up
//                 </button>
//               </div>
//             </ul>
//           </div>
//         )}
//       </nav>  
//     </>
//   );
// };

// export default Header;




// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { 
//   Menu, 
//   X, 
//   ChevronDown, 
//   ArrowRight, 
//   ChevronRight, 
//   MessageSquare, 
//   ShieldCheck, 
//   Code, 
//   PhoneCall, 
//   Mic, 
//   PhoneMissed, 
//   Users, 
//   Smartphone, 
//   MessageCircle, 
//   Bot, 
//   Mail as MailIcon, 
//   Radio,
//   Briefcase, 
//   Newspaper,
//   Building2,      
//   HeartPulse,     
//   Landmark,       
//   GraduationCap,  
//   WifiOff,        
//   BadgeCheck,     
//   Megaphone,      
//   FileSpreadsheet,
//   BookOpen,       
//   HelpCircle,     
//   FileCheck       
// } from "lucide-react";
// import eurofoxlogo from "../assets/eurofoxlogo.png";
// import company from "../assets/gifphone2.gif"

// const Header = () => {
//   const [open, setOpen] = useState(false); // Mobile Menu State
//   const [mobileSubMenu, setMobileSubMenu] = useState(""); 
//   const [activeDropdown, setActiveDropdown] = useState(null); // Desktop Dropdown State
//   const dropdownRef = useRef(null); // To detect clicks outside
//   const navigate = useNavigate();

//   // --- Click Outside Logic to close dropdowns ---
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setActiveDropdown(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // --- HANDLERS ---
//   const handleLoginClick = () => {
//     setActiveDropdown(null); 
//     navigate("/login");
//   };
  
//   const handleSignupClick = () => {
//     setActiveDropdown(null); 
//     navigate("/login?mode=signup");
//   };
  
//   const handleRequestDemo = () => {
//     setActiveDropdown(null); 
//     navigate("/contact");
//   };

//   const toggleMobileSubMenu = (menuName) => {
//     setMobileSubMenu(mobileSubMenu === menuName ? "" : menuName);
//   };

//   const toggleDesktopDropdown = (menuName) => {
//     setActiveDropdown(activeDropdown === menuName ? null : menuName);
//   };

//   // --- Navigation Data Configuration ---
//   const navItems = [
//     {
//       name: "Products",
//       type: "grid", 
//       items: [
//         { name: "Bulk SMS", icon: MessageSquare, link: "/products/bulk-sms" },
//         { name: "Lead Management System", icon: Users, link: "/products/lms" },
//         { name: "OTP Services", icon: ShieldCheck, link: "/products/otp" },
//         { name: "WhatsApp API", icon: MessageCircle, link: "/products/whatsapp" },
//         { name: "IVR Service", icon: Mic, link: "/products/ivr" },
//         { name: "Virtual Phone No.", icon: Smartphone, link: "/products/virtual-number" },
//         { name: "Missed Call Alert Services", icon: PhoneMissed, link: "/products/missed-call" },
//         { name: "Employee Tracking System", icon: Radio, link: "/products/employee-tracking-system" },
//       ]
//     },
//     // {
//     //   name: "Solutions",
//     //   type: "grid", 
//     //   items: [
//     //     { name: "Real Estate", icon: Building2, link: "/solutions/real-estate" },
//     //     { name: "Campaign Management", icon: Megaphone, link: "/solutions/campaign-manager" },
//     //     { name: "Banking & Finance", icon: Landmark, link: "/solutions/finance" },
//     //     { name: "Offline SMS", icon: WifiOff, link: "/solutions/offline-sms" },
//     //     { name: "Healthcare", icon: HeartPulse, link: "/solutions/healthcare" },
//     //     { name: "Verified SMS", icon: BadgeCheck, link: "/solutions/verified-sms" },
//     //     { name: "Education", icon: GraduationCap, link: "/solutions/education" },
//     //     { name: "Excel Plugin", icon: FileSpreadsheet, link: "/solutions/excel-plugin" }
//     //   ]
//     // },
//     // --- COMPANY (Moved AFTER Solutions) ---
//     {
//       name: "Company",
//       type: "split", 
//       items: [
//         { name: "About Us", icon: Users, link: "/about", desc: "Our story, mission & values" },
//         { name: "Contact Us", icon: PhoneCall, link: "/contact", desc: "Get in touch with support" },
//         { name: "Career", icon: Briefcase, link: "/company/careers", desc: "Join our dynamic team" }, 
//         // { name: "News", icon: Newspaper, link: "/company/news", desc: "Stay updated with news" } 
//         { name: "News", icon: Newspaper, desc: "Stay updated with news" } 

//       ]
//     },
//     {
//       name: "Resources",
//       type: "grid", 
//       items: [
//         { name: "Blog", icon: Newspaper, link: "/resources/blog" },
//         { name: "FAQ", icon: HelpCircle, link: "/resources/faq" },
//         // { name: "User Guide", icon: BookOpen, link: "/resources/user-guide" },
//         { name: "User Guide", icon: BookOpen, },
//         { name: "DLT Registration", icon: FileCheck, link: "/resources/dlt-registration" }
//       ]
//     }
//   ];

//   return (
//     <>
//       {/* =========================================================
//           TOP BAR
//       ========================================================= */}
//       <div className="w-full bg-[#0C4550] py-1.5 text-white relative z-50">
//         <div className="w-full mx-auto px-5 flex items-center justify-between">
//           <div className="flex items-center space-x-4 text-sm font-medium tracking-wide">
//              {/* Optional Left Content */}
//           </div>
//           <div className="flex items-center space-x-6 text-sm font-medium">
//             <button onClick={handleLoginClick} className="hover:text-[#C5F637] transition-colors duration-300">
//               Login
//             </button>
//             <span className="text-gray-500">|</span>
//             <button onClick={handleSignupClick} className="hover:text-[#C5F637] transition-colors duration-300">
//               Sign Up
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* =========================================================
//           MAIN NAVIGATION
//       ========================================================= */}
//       <nav className="w-full bg-white shadow-md sticky top-0 z-40" ref={dropdownRef}>
//         <div className="w-full mx-auto px-5 py-2 flex items-center justify-between relative">
            
//           {/* 1. LEFT: EUROFOX LOGO */}
//           <div className="flex items-center flex-shrink-0">
//             <Link 
//               to="/" 
//               onClick={() => setActiveDropdown(null)}
//               className="group cursor-pointer no-underline flex items-center relative min-h-[40px]"
//             >
//               <img 
//                 src={eurofoxlogo} 
//                 alt="Eurofox Logo" 
//                 className="absolute top-1/2 -translate-y-1/2 left-0 w-36 h-36 md:w-36 md:h-36 object-contain transition-all duration-300 drop-shadow-md z-50"
//               />
//               <h1 className="ml-24 md:ml-22 text-2xl font-extrabold tracking-widest uppercase flex items-baseline transition-all duration-300">
//                 <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] ">EURO</span>
//                 <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">FOX</span>
//                 <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
//               </h1>
//             </Link>
//           </div>

//           {/* 2. CENTER: Desktop Menu */}
//           <ul className="hidden lg:flex items-center space-x-6 xl:space-x-8 text-[15px] font-medium text-[#0C1B2C]">
//             {navItems.map((item) => (
//               <li key={item.name} className="relative py-4">
//                 <button 
//                   onClick={() => toggleDesktopDropdown(item.name)}
//                   className="flex items-center gap-1 transition-colors"
//                 >
//                   {item.name}
//                   <ChevronDown 
//                     size={14} 
//                     className={`transition-transform duration-300 ${activeDropdown === item.name ? "rotate-180" : ""}`} 
//                   />
//                 </button>

//                 {/* Dropdown Content */}
//                 <div 
//                   className={`absolute top-full mt-6 transform bg-white rounded-xl shadow-2xl border-[6px] border-[#EEF2FC] transition-all duration-300 z-50 overflow-hidden
//                     ${activeDropdown === item.name 
//                       ? "opacity-100 visible translate-y-0" 
//                       : "opacity-0 invisible translate-y-4 pointer-events-none"}
//                     ${
//                         item.type === "grid" ? "w-[650px] left-0 translate-x-[-20%]" : 
//                         item.type === "split" ? "w-[600px] left-1/2 -translate-x-1/2" :
//                         "w-56 left-1/2 -translate-x-1/2"
//                       }
//                   `}
//                 >
                    
//                     <div className="p-4">
//                       {item.type === "grid" ? (
//                         // --- GRID LAYOUT ---
//                         <div className="grid grid-cols-2 gap-x-6 gap-y-2">
//                           {item.items.map((subItem) => (
//                             <Link 
//                               key={subItem.name} 
//                               to={subItem.link} 
//                               onClick={() => setActiveDropdown(null)}
//                               className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#EEF2FC] group transition-all"
//                             >
//                               <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#0C4550]/10 flex items-center justify-center text-[#0C4550] group-hover:bg-[#0C4550] group-hover:text-white transition-colors">
//                                 {subItem.icon && <subItem.icon size={16} />}
//                               </div>
//                               <div>
//                                 <h6 className="text-sm font-semibold text-gray-800 transition-colors">{subItem.name}</h6>
//                               </div>
//                             </Link>
//                           ))}
//                         </div>
//                       ) : item.type === "split" ? (
//                         // --- SPLIT LAYOUT FOR COMPANY ---
//                         <div className="flex gap-4">
//                             {/* Left Side: Menu Items - HEIGHT MATCHED TO IMAGE */}
//                             <div className="w-1/2 flex flex-col h-72"> 
//                                 {item.items.map((subItem) => (
//                                     <Link 
//                                     key={subItem.name} 
//                                     to={subItem.link} 
//                                     onClick={() => setActiveDropdown(null)}
//                                     // Flex-1 ensures items fill the vertical space equally
//                                     className="flex-1 flex items-center gap-3 px-3 rounded-xl hover:bg-[#EEF2FC] group transition-all"
//                                     >
//                                     <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#0C4550]/10 flex items-center justify-center text-[#0C4550] group-hover:bg-[#0C4550] group-hover:text-white transition-colors">
//                                         {subItem.icon && <subItem.icon size={18} />}
//                                     </div>
//                                     <div className="flex flex-col">
//                                         <h6 className="text-[15px] font-semibold text-gray-800 transition-colors leading-none mb-1">
//                                             {subItem.name}
//                                         </h6>
//                                         {/* Subheading */}
//                                         <span className="text-[11px] text-gray-700 font-medium leading-tight">
//                                             {subItem.desc}
//                                         </span>
//                                     </div>
//                                     </Link>
//                                 ))}
//                             </div>
                            
//                             {/* Right Side: Image Placeholder - Fixed Height h-72 */}
//                             <div className="w-1/2 p-2 flex items-center justify-center">
//                                 <div className="relative w-full h-72 overflow-hidden rounded-xl border border-gray-100 shadow-sm group">
//                                     <img 
//                                         src={company} 
//                                         alt="Company Culture" 
//                                         className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                       ) : (
//                         // --- STANDARD LIST LAYOUT ---
//                         <div className="flex flex-col">
//                           {item.items.map((subItem) => (
//                             <Link 
//                               key={subItem.name} 
//                               to={subItem.link} 
//                               onClick={() => setActiveDropdown(null)}
//                               className="block px-4 py-2.5 text-gray-600 hover:text-[#0C4550] hover:bg-gray-50 text-sm rounded-md transition-colors"
//                             >
//                               {subItem.name}
//                             </Link>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                 </div>
//               </li>
//             ))}

//             <li>
//               <Link 
//                 to="/pricing" 
//                 onClick={() => setActiveDropdown(null)}
//                 className="transition-colors "
//               >
//                 Pricing
//               </Link>
//             </li>
//           </ul>

//           {/* 3. RIGHT: Request A Demo */}
//           <div className="flex items-center gap-4">
//             <button
//               onClick={handleRequestDemo}
//               className="hidden md:flex items-center gap-3 pl-6 pr-2 py-2 text-sm font-medium text-white bg-[#F46653] rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 group"
//             >
//               <span>Request a Demo</span>
//               <div className="bg-white text-[#F46653] p-1.5 rounded-full flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
//                 <ArrowRight size={16} />
//               </div>
//             </button>

//             {/* Mobile Menu Toggle */}
//             <button className="lg:hidden text-[#0C4550]" onClick={() => setOpen(!open)}>
//               {open ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>

//         {/* =========================================================
//             MOBILE DROPDOWN MENU
//         ========================================================= */}
//         {open && (
//           <div className="lg:hidden bg-white shadow-lg border-t absolute w-full left-0 h-screen overflow-y-auto pb-20 z-[60]">
//             <div className="flex flex-col p-5 space-y-2">
                
//               {navItems.map((item) => (
//                 <div key={item.name} className="border-b border-gray-100 last:border-0">
//                   <button 
//                     onClick={() => toggleMobileSubMenu(item.name)}
//                     className="flex items-center justify-between w-full py-3 text-lg font-medium text-gray-700"
//                   >
//                     {item.name}
//                     <ChevronRight 
//                       size={18} 
//                       className={`text-gray-400 transition-transform duration-300 ${mobileSubMenu === item.name ? "rotate-90" : ""}`} 
//                     />
//                   </button>
                    
//                   <div className={`overflow-hidden transition-all duration-300 ${mobileSubMenu === item.name ? "max-h-[500px] opacity-100 mb-3" : "max-h-0 opacity-0"}`}>
//                     <ul className="bg-gray-50 rounded-lg p-2 space-y-1">
//                       {item.items.map((subItem) => (
//                         <li key={subItem.name}>
//                           <Link 
//                              to={subItem.link} 
//                              className="flex items-center gap-3 px-4 py-3 text-gray-600 hover:text-[#0C4550]"
//                              onClick={() => setOpen(false)}
//                           >
//                             {subItem.icon && <subItem.icon size={16} className="text-[#F46653]" />}
//                             <div className="flex flex-col">
//                                 <span>{subItem.name}</span>
//                             </div>
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               ))}

//               <Link
//                 to="/pricing"
//                 className="block py-3 text-lg font-medium text-gray-700 border-b border-gray-100"
//                 onClick={() => setOpen(false)}
//               >
//                 Pricing
//               </Link>

//               {/* Mobile Buttons */}
//               <div className="flex flex-col space-y-3 pt-6">
//                 <button
//                   onClick={() => { handleRequestDemo(); setOpen(false); }}
//                   className="w-full flex justify-center items-center gap-2 px-6 py-3.5 bg-[#F46653] text-white font-bold rounded-xl shadow-md active:scale-95 transition-transform"
//                 >
//                   Request a Demo
//                   <ArrowRight size={18} />
//                 </button>

//                 <div className="flex gap-3 pt-2">
//                   <button 
//                     onClick={() => { handleLoginClick(); setOpen(false); }} 
//                     className="flex-1 px-4 py-3 text-[#0C4550] font-bold rounded-xl border border-gray-200 bg-gray-50"
//                   >
//                     Login
//                   </button>
//                   <button 
//                     onClick={() => { handleSignupClick(); setOpen(false); }}
//                     className="flex-1 px-4 py-3 bg-[#0C4550] text-white font-bold rounded-xl"
//                   >
//                     Sign Up
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </nav>
//     </>
//   );
// };

// export default Header;






import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { 
 Menu, 
  X, 
  ChevronDown, 
  ArrowRight, 
  ChevronRight, 
  MessageSquare, 
  ShieldCheck, 
  Code, 
  PhoneCall, 
  Mic, 
  PhoneMissed, 
  Users, 
  Smartphone, 
  MessageCircle, 
  Bot, 
  Mail as MailIcon, 
  Radio,
  Briefcase, 
  Newspaper,
  Building2,      
  HeartPulse,     
  Landmark,       
  GraduationCap,  
  WifiOff,        
  BadgeCheck,     
  Megaphone,      
  FileSpreadsheet,
  BookOpen,       
  HelpCircle,     
  FileCheck, 
  Plane,
  ShoppingCart
} from "lucide-react";
import eurofoxlogo from "../assets/eurofoxlogo.png";
import company from "../assets/gifphone2.gif";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [mobileSubMenu, setMobileSubMenu] = useState(""); 
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLoginClick = () => { navigate("/login"); setActiveDropdown(null); };
  const handleSignupClick = () => { navigate("/login?mode=signup"); setActiveDropdown(null); };
  const handleRequestDemo = () => { navigate("/contact"); setActiveDropdown(null); };

  const navItems = [
    {
      name: "Products",
      type: "grid", 
      items: [
        { name: "Bulk SMS", icon: MessageSquare, link: "/products/bulk-sms" },
        { name: "Lead Management System", icon: Users, link: "/products/lms" },
        { name: "OTP Services", icon: ShieldCheck, link: "/products/otp" },
        { name: "WhatsApp API", icon: MessageCircle, link: "/products/whatsapp" },
        { name: "IVR Service", icon: Mic, link: "/products/ivr" },
        { name: "Virtual Phone No.", icon: Smartphone, link: "/products/virtual-number" },
        { name: "Missed Call Alert Services", icon: PhoneMissed, link: "/products/missed-call" },
        { name: "Employee Tracking System", icon: Radio, link: "/products/employee-tracking-system" },
      ]
    },

      {
      name: "Solutions",
      type: "grid", 
      items: [
        { name: "Education", icon: GraduationCap, link: "/solutions/education" },
        // { name: "Campaign Management", icon: Megaphone, link: "/solutions/campaign-manager" },
        { name: "Real Estate", icon: Building2, link: "/solutions/real-estate" },
        // { name: "Offline SMS", icon: WifiOff, link: "/solutions/offline-sms" },
        { name: "Healthcare", icon: HeartPulse, link: "/solutions/healthcare" },
        // { name: "Verified SMS", icon: BadgeCheck, link: "/solutions/verified-sms" },
        { name: "Banking & Finance", icon: Landmark, link: "/solutions/finance" },
        // { name: "Excel Plugin", icon: FileSpreadsheet, link: "/solutions/excel-plugin" }
        { name: "Travel", icon: Plane, link: "/solutions/travel" },
        { name: "E-Commerce", icon: ShoppingCart, link: "/solutions/e-commerce" },



      ]
    },
    {
      name: "Company",
      type: "split", 
      items: [
        { name: "About Us", icon: Users, link: "/about", desc: "Our story, mission & values" },
        { name: "Contact Us", icon: PhoneCall, link: "/contact", desc: "Get in touch with support" },
        { name: "Career", icon: Briefcase, link: "/company/careers", desc: "Join our dynamic team" }, 
        { name: "News", icon: Newspaper, desc: "Stay updated with news" } 
      ]
    },
    {
      name: "Resources",
      type: "grid", 
      items: [
        { name: "Blog", icon: Newspaper, link: "/resources/blog" },
        { name: "FAQ", icon: HelpCircle, link: "/resources/faq" },
        { name: "User Guide", icon: BookOpen },
        { name: "DLT Registration", icon: FileCheck, link: "/resources/dlt-registration" }
      ]
    }
  ];

  return (
    <>
      {/* TOP BAR */}
      <div className="w-full bg-[#0C4550] py-1.5 text-white relative z-50">
        <div className="w-full mx-auto px-5 flex items-center justify-between">
          <div className="flex items-center space-x-4 text-sm font-medium tracking-wide"></div>
          <div className="flex items-center space-x-6 text-sm font-medium">
            <button onClick={handleLoginClick} className="hover:text-[#C5F637] transition-colors duration-300">Login</button>
            <span className="text-gray-500">|</span>
            <button onClick={handleSignupClick} className="hover:text-[#C5F637] transition-colors duration-300">Sign Up</button>
          </div>
        </div>
      </div>

      {/* MAIN NAVIGATION */}
      <nav className="w-full bg-white shadow-md sticky top-0 z-40" ref={dropdownRef}>
        <div className="w-full mx-auto px-5 py-2 flex items-center justify-between relative min-h-[60px]">
          
          {/* --- DESKTOP LOGO (UNTOUCHED) --- */}
          <div className="hidden lg:flex items-center flex-shrink-0">
            <Link to="/" onClick={() => setActiveDropdown(null)} className="group cursor-pointer no-underline flex items-center relative min-h-[40px]">
              <img src={eurofoxlogo} alt="Eurofox Logo" className="absolute top-1/2 -translate-y-1/2 left-0 w-36 h-36 md:w-36 md:h-36 object-contain transition-all duration-300 drop-shadow-md z-50" />
              <h1 className="ml-24 md:ml-22 text-2xl font-extrabold tracking-widest uppercase flex items-baseline transition-all duration-300">
                <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)] ">EURO</span>
                <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">FOX</span>
                <span className="w-2.5 h-2.5 rounded-full bg-[#F46653] ml-1 animate-pulse shadow-sm"></span>
              </h1>
            </Link>
          </div>

          {/* --- MOBILE LOGO (MATCHING DESKTOP STYLE EXACTLY) --- */}
          <div className="flex lg:hidden items-center flex-shrink-0">
            <Link to="/" onClick={() => setOpen(false)} className="flex items-center relative min-h-[50px]">
              {/* Increased size (w-28) and shifted more left (-left-7) */}
              <img 
                src={eurofoxlogo} 
                alt="Mobile Logo" 
                className="absolute top-1/2 -translate-y-1/2 -left-11 w-28 h-28 object-contain drop-shadow-lg z-50" 
              />
              {/* Matching Desktop Text Style: Font weight, Spacing, and Drop Shadow */}
              <h1 className="ml-7 text-[22px] font-extrabold tracking-widest uppercase flex items-baseline">
                <span className="font-['Roboto'] text-[#0C4550] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">EURO</span>
                <span className="font-['Roboto'] text-[#F46653] drop-shadow-[1px_1px_0px_rgba(12,69,80,1)]">FOX</span>
                <span className="w-2 h-2 rounded-full bg-[#F46653] ml-0.5 animate-pulse shadow-sm"></span>
              </h1>
            </Link>
          </div>

          {/* DESKTOP MENU (UNTOUCHED) */}
          <ul className="hidden lg:flex items-center space-x-6 xl:space-x-8 text-[15px] font-medium text-[#0C1B2C]">
            {navItems.map((item) => (
              <li key={item.name} className="relative py-4">
                <button onClick={() => setActiveDropdown(activeDropdown === item.name ? null : item.name)} className="flex items-center gap-1 transition-colors">
                  {item.name}
                  <ChevronDown size={14} className={`transition-transform duration-300 ${activeDropdown === item.name ? "rotate-180" : ""}`} />
                </button>
                <div className={`absolute top-full mt-6 transform bg-white rounded-xl shadow-2xl border-[6px] border-[#EEF2FC] transition-all duration-300 z-50 overflow-hidden
                    ${activeDropdown === item.name ? "opacity-100 visible translate-y-0" : "opacity-0 invisible translate-y-4 pointer-events-none"}
                    ${item.type === "grid" ? "w-[650px] left-0 translate-x-[-20%]" : item.type === "split" ? "w-[600px] left-1/2 -translate-x-1/2" : "w-56 left-1/2 -translate-x-1/2"}
                  `}>
                  <div className="p-4">
                    {item.type === "grid" ? (
                      <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                        {item.items.map((subItem) => (
                          <Link key={subItem.name} to={subItem.link} onClick={() => setActiveDropdown(null)} className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#EEF2FC] group transition-all">
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#0C4550]/10 flex items-center justify-center text-[#0C4550] group-hover:bg-[#0C4550] group-hover:text-white transition-colors">
                              {subItem.icon && <subItem.icon size={16} />}
                            </div>
                            <h6 className="text-sm font-semibold text-gray-800 transition-colors">{subItem.name}</h6>
                          </Link>
                        ))}
                      </div>
                    ) : item.type === "split" ? (
                      <div className="flex gap-4">
                        <div className="w-1/2 flex flex-col h-72"> 
                          {item.items.map((subItem) => (
                            <Link key={subItem.name} to={subItem.link} onClick={() => setActiveDropdown(null)} className="flex-1 flex items-center gap-3 px-3 rounded-xl hover:bg-[#EEF2FC] group transition-all">
                              <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#0C4550]/10 flex items-center justify-center text-[#0C4550] group-hover:bg-[#0C4550] group-hover:text-white transition-colors">
                                {subItem.icon && <subItem.icon size={18} />}
                              </div>
                              <div className="flex flex-col">
                                <h6 className="text-[15px] font-semibold text-gray-800 transition-colors leading-none mb-1">{subItem.name}</h6>
                                <span className="text-[11px] text-gray-700 font-medium leading-tight">{subItem.desc}</span>
                              </div>
                            </Link>
                          ))}
                        </div>
                        <div className="w-1/2 p-2 flex items-center justify-center">
                          <div className="relative w-full h-72 overflow-hidden rounded-xl border border-gray-100 shadow-sm group">
                            <img src={company} alt="Company Culture" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col">
                        {item.items.map((subItem) => (
                          <Link key={subItem.name} to={subItem.link} onClick={() => setActiveDropdown(null)} className="block px-4 py-2.5 text-gray-600 hover:text-[#0C4550] hover:bg-gray-50 text-sm rounded-md transition-colors">
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </li>
            ))}
            <li><Link to="/pricing" onClick={() => setActiveDropdown(null)}>Pricing</Link></li>
          </ul>

          {/* RIGHT SIDE ACTIONS */}
          <div className="flex items-center gap-4">
            <button onClick={handleRequestDemo} className="hidden md:flex items-center gap-3 pl-6 pr-2 py-2 text-sm font-medium text-white bg-[#F46653] rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 group">
              <span>Request a Demo</span>
              <div className="bg-white text-[#F46653] p-1.5 rounded-full flex items-center justify-center group-hover:translate-x-1 transition-transform duration-300">
                <ArrowRight size={16} />
              </div>
            </button>
            <button className="lg:hidden text-[#0C4550]" onClick={() => setOpen(!open)}>
              {open ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* MOBILE DROPDOWN MENU */}
        {open && (
          <div className="lg:hidden bg-white shadow-lg border-t absolute w-full left-0 h-screen overflow-y-auto pb-20 z-[60]">
            <div className="flex flex-col p-5 space-y-2">
              {navItems.map((item) => (
                <div key={item.name} className="border-b border-gray-100 last:border-0">
                  <button onClick={() => setMobileSubMenu(mobileSubMenu === item.name ? "" : item.name)} className="flex items-center justify-between w-full py-3 text-lg font-medium text-gray-700">
                    {item.name}
                    <ChevronRight size={18} className={`text-gray-400 transition-transform duration-300 ${mobileSubMenu === item.name ? "rotate-90" : ""}`} />
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${mobileSubMenu === item.name ? "max-h-[500px] opacity-100 mb-3" : "max-h-0 opacity-0"}`}>
                    <ul className="bg-gray-50 rounded-lg p-2 space-y-1">
                      {item.items.map((subItem) => (
                        <li key={subItem.name}>
                          <Link to={subItem.link} className="flex items-center gap-3 px-4 py-3 text-gray-600 hover:text-[#0C4550]" onClick={() => setOpen(false)}>
                            {subItem.icon && <subItem.icon size={16} className="text-[#F46653]" />}
                            <span>{subItem.name}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
              <Link to="/pricing" className="block py-3 text-lg font-medium text-gray-700 border-b border-gray-100" onClick={() => setOpen(false)}>Pricing</Link>
              <div className="flex flex-col space-y-3 pt-6">
                <button onClick={() => { handleRequestDemo(); setOpen(false); }} className="w-full flex justify-center items-center gap-2 px-6 py-3.5 bg-[#F46653] text-white font-bold rounded-xl shadow-md active:scale-95 transition-transform">
                  Request a Demo <ArrowRight size={18} />
                </button>
                <div className="flex gap-3 pt-2">
                  <button onClick={() => { handleLoginClick(); setOpen(false); }} className="flex-1 px-4 py-3 text-[#0C4550] font-bold rounded-xl border border-gray-200 bg-gray-50">Login</button>
                  <button onClick={() => { handleSignupClick(); setOpen(false); }} className="flex-1 px-4 py-3 bg-[#0C4550] text-white font-bold rounded-xl">Sign Up</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Header;